export default (function () {
    const sort = {
        initMobile() {
            $(document).on('click', '.js--show_sort', () => {
                $('.js--mob_sort').addClass('show');
                $('body').addClass('overlay_bg_dark');
            });
            $(document).on('click', '.js--mob_sort_submit', () => {
                const sortType = $('.js--mob_sort_label:checked').data('value');
                $('.js--quick_sort-item').filter((i, item) => $(item).data('value') === sortType).trigger('click');
                $('.js--mob_sort').removeClass('show');
                $('body').removeClass('overlay_bg_dark');
            });
        },
    };
    $(document).ready(() => {
        sort.initMobile();
    });
}());
